export type EmailTemplate = {
  subject: string
  body: string
}

export type EmailTemplates = {
  [key: string]: EmailTemplate | undefined
}

export const DEFAULT_TEMPLATES: EmailTemplates = {
  reportCompletion: {
    subject:
      'Congratulations! You have completed your {monthName} {year} monthly check-in',
    body: 'Thank you for completing your monthly check-in, your participation is helping find solutions for all those with ALS.',
  },
}
